
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"20","height":"19"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","fill":"#FF8A00","d":"M19.355 10.62l-8.453 3.8c-.809.353-1.132.353-1.879 0L.57 10.62C.121 10.382 0 9.5 0 9.019a16.65 16.65 0 001.328.663l8.635 3.981 8.634-3.981c.015-.003.784-.391 1.328-.663 0 .492-.153 1.407-.57 1.601zm0-3.98l-8.453 3.8c-.809.352-1.132.352-1.879 0L.57 6.64c-.664-.353-.644-1.462 0-1.877L9.023.3c.747-.373 1.215-.394 1.879 0l8.453 4.463c.644.353.623 1.587 0 1.877zM9.963 1.057L1.328 5.701 9.963 9.34l8.634-3.639-8.634-4.644zm0 0c.046.015.062.073 0 0zm0 16.586l8.634-3.98c.015-.004.784-.392 1.328-.664 0 .493-.153 1.408-.57 1.602l-8.453 3.8c-.809.352-1.132.352-1.879 0l-8.453-3.8c-.449-.238-.57-1.12-.57-1.602.564.323 1.358.682 1.328.664l8.635 3.98z"}})])
          )
        }
      }
    